import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ContactRequestPage } from './contact-request';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    ContactRequestPage,
  ],
  imports: [
    IonicPageModule.forChild(ContactRequestPage),
    ComponentsModule,
  ],
})
export class ContactRequestPageModule {}



// WEBPACK FOOTER //
// ./src/pages/contact-request/contact-request.module.ts